export enum eTypeMessage {
    Server = 0,
    User = 1,
    Galery = 2,
    AnswerUser = 3
}